import MemberGate from "@/components/feature/MemberGate";
import SubmitBannerNavbar from "@/pages/submit-banner/components/SubmitBannerNavbar";
import MyBannersList from "./components/MyBannersList";

export default function MyBanners() {
  return (
    <div className="min-h-screen bg-beige">
      <SubmitBannerNavbar />
      <div className="pt-24 pb-16 md:pt-32 md:pb-24">
        <MemberGate>
          <MyBannersList />
        </MemberGate>
      </div>
    </div>
  );
}